let cn = {
    HOME: "首页",
    ACCOUNTCONFIG: "账号设置",
    TENDERINFO: "招标信息",
    BIDDINGLIST: "标书询价单列表",
    BIDDEDLIST: "已投标",
    NOBIDLIST: "未投标",
    APPDOWNLOAD: "APP下载"
};
let tw = {
    HOME: "首頁",
    ACCOUNTCONFIG: "帳號設定",
    TENDERINFO: "招標資訊",
    BIDDINGLIST: "標書詢價單列表",
    BIDDEDLIST: "已投標",
    NOBIDLIST: "未投標",
    APPDOWNLOAD: "APP下載"
};
let en = {
    HOME: 'Home Page',
    ACCOUNTCONFIG: 'Account Settings',
    TENDERINFO: "Tendering Information",
    BIDDINGLIST: "Bid Inquiry List",
    BIDDEDLIST: "Bidded",
    NOBIDLIST: "No bid",
    APPDOWNLOAD: "APP download"
}

export {
    cn,
    tw,
    en
}